import React from "react";
import { truncate } from "lodash";

const UserInformation = ({ information }) => {
  return (
    <div className="widget-news-content">
      <p
        style={information ? { textAlign: "justify" } : { textAlign: "center" }}
      >
        {information
          ? truncate(information, { length: 270, separator: "..." })
          : "No Info Available"}
      </p>
    </div>
  );
};

export default UserInformation;



// WEBPACK FOOTER //
// ./src/_components/UI/UserWidget/UserInformation/index.js